export enum QuickAccessContext {
  ADMIN = "admin",
  MANDANT = "mandant",
}
